/**
 * 소유자(사장)를 다른 소유자의 소속자(직원)로 이전하는 모달 ($j.Ui.JBModal.target 결합).
 * 수발주자 전용. 장비 소유권이 새 소유자로 넘어가고 캐시/하위소속자가 있으면 서버에서 차단된다.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('transfer-modal', {
 *       target: '$j.F.Admin.Member.TransferForm',
 *       data:   { mbNo: 123, mbName: '홍길동' },
 *       title:  '소속자로 이전',
 *       width:  '520px',
 *   });
 */
export default class TransferForm {
    constructor() { this.inputId = 'transfer-owner-input'; }
    destroy() {}

    init() {
        this.mbNo = this.data.mbNo;
        this.mbName = this.data.mbName || '';
        this.render();
        this.bind();
    }

    render() {
        // 스타일은 `admin/components/_transfer-form.scss` 에 있다.
        // 여기서 <style> 을 주입하지 않는다 — 리터럴 색이 박혀 다크·'부드럽게' 테마를
        // 통째로 비켜갔던 자리다 (CLAUDE.md '관리자 화면설정 테마' 2항).
        const e = (v) => $('<i>').text(v == null ? '' : v).html();

        $(`#${this.id}`).html(`
        <div class="transfer-form">
            <div class="tf-guide">
                <b>[${e(this.mbName)}]</b> 소유자를 다른 소유자의 <b>소속자</b>로 이전합니다.<br>
                · 본인 소유 장비의 <b>소유권이 새 소유자로 이전</b>됩니다(운전은 계속).<br>
                · 보유머니/수주홀드/진행오더, 하위 소속자가 있으면 이전할 수 없습니다.<br>
                · 되돌리기 어려우니 신중히 실행하세요.
            </div>
            <div class="tf-row">
                <label for="${this.inputId}">새 소유자</label>
                <input type="text" class="me-input" id="${this.inputId}"
                       placeholder="이름 또는 회원번호로 검색">
            </div>
            <div class="tf-hint">목록에서 고르면 <b>이름#번호</b> 로 채워집니다. 회원번호를 직접 적어도 됩니다.</div>
            <div class="tf-foot">
                <button type="button" id="transfer-exec-btn" class="tf-exec">소속자로 이전</button>
            </div>
        </div>`);
    }

    bind() {
        const self = this;
        // 회원 자동완성 — 관리자 공용 규약(`이름#번호`)을 그대로 쓴다.
        // 숫자만 받던 칸이라 사장 회원번호를 외우거나 다른 화면에서 찾아와야 했다.
        // ⚠ 예전 '숫자만 입력' 필터는 뺐다 — 이름을 못 치면 자동완성이 무용지물이다.
        $j.F.Admin.Util.memberSearch(self.inputId);
        $(`#${self.id}`).find('#transfer-exec-btn').off('click').on('click', () => self.save());
    }

    /**
     * 입력칸에서 회원번호를 읽는다.
     *
     * **보이는 텍스트가 곧 값이다** (CLAUDE.md '검색 인풋에 숨은 상태를 두지 않는다').
     * hidden 이나 data-value 에 번호를 숨기면 표시값과 어긋나도 사용자가 알 수 없다.
     *   이재일#2831 → 2831   (자동완성에서 고름)
     *   2831        → 2831   (직접 입력)
     *   이재일       → 0      (누구인지 정해지지 않았다 — 동명이인이 있다)
     */
    pickedNo() {
        const v = String($(`#${this.inputId}`).val() || '').trim();
        const m = v.match(/#(\d+)$/);
        if (m) return parseInt(m[1], 10);
        return /^\d+$/.test(v) ? parseInt(v, 10) : 0;
    }

    save() {
        const self = this;
        const newOwnerNo = self.pickedNo();
        if (!newOwnerNo) {
            $j.F.Admin.Util.tsalert('error', '새 소유자를 목록에서 고르거나 회원번호를 입력하세요.');
            return;
        }
        if (newOwnerNo === parseInt(self.mbNo)) { $j.F.Admin.Util.tsalert('error', '같은 회원으로는 이전할 수 없습니다.'); return; }
        if (!confirm(`[${self.mbName}] 회원을 새 소유자(#${newOwnerNo})의 소속자로 이전할까요?\n장비 소유권이 새 소유자로 넘어가며 되돌리기 어렵습니다.`)) return;

        $.ajax({
            type: 'POST',
            url: '/adm/ajax/member/transfer',
            data: { mb_no: self.mbNo, new_owner_no: newOwnerNo },
            dataType: 'json',
            success(data) {
                if (data.result) {
                    $j.F.Admin.Util.tsalert('success', data.message || '소속자로 이전되었습니다.');
                    $j.Ui.JBModal.close('transfer-modal');
                    location.replace(`/adm/member/edit?mb_no=${self.mbNo}`);
                } else {
                    $j.F.Admin.Util.tsalert('error', data.message || '이전에 실패했습니다.');
                }
            },
            error(xhr) { alert(`요청 중 오류가 발생했습니다. (${xhr.status})`); },
        });
    }
}
